import axios from "@/utils/axios.js";

/**
 * 获取推荐经纪人列表
 * @param {string} tel 电话号码
 * @param {string} agentId 经纪人ID
 */
export async function getUserByTelOrIntroAgent(tel, agentId, url) {
  return axios.get(
    `/agentLogin/getUserByTelOrIntroAgentNew?tel=${tel}&agentId=${agentId}&url=${url}`
  );
}
